/**
 * Identifiers of outlets inside the cart details view.
 */
export enum CartOutlets {
  ITEM = 'cx-cart-item',
  ITEM_DETAILS = 'cx-cart-item.details',
  ITEM_BUNDLE_DETAILS = 'cx-cart-item.bundle-details',
}
